import { Button, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { Dispatch, SetStateAction, useContext, useEffect } from "react";
import { BannerCouponName } from "schemas/dashboard";

import { CLOSE_VA_ANNOUNCEMENT } from "constants/influencer";

import styles from "./styles";

interface Props {
  close: boolean;
  setClose: Dispatch<SetStateAction<boolean>>;
}

const VAAnnouncement = ({ close, setClose }: Props) => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const closeFromSessionStorage =
    sessionStorage.getItem(`${CLOSE_VA_ANNOUNCEMENT}-${currentOrg?.id}`) ===
    "true";
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const { subscription } = useContext(SubscriptionContext);
  const isMoneyBackGuarantee =
    subscription?.bannerPromoCode?.couponName ===
    BannerCouponName.money_back_guarantee;

  const trackLearnMore = () => {
    setUpgradeDialogSource("Upgrade VA Button");
  };

  useEffect(() => {
    if (closeFromSessionStorage && !close) {
      setClose(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeFromSessionStorage]);

  return (
    <Grid container item xs sx={styles.container} alignItems="center" gap={2}>
      <Grid item xs={12} md>
        <Typography
          component="div"
          variant="h6"
          sx={{ mb: 1, fontSize: { xs: 15, sm: 16 } }}
        >
          🏇{" "}
          {isMoneyBackGuarantee
            ? "AI Virtual Assistant- Money-back guarantee promotion until Dec. 8th"
            : "Want a Virtual Assistant to pitch for you?"}
        </Typography>

        <Typography
          sx={{ color: grey[700], fontSize: { xs: 12, sm: 14 } }}
          gutterBottom
        >
          {isMoneyBackGuarantee
            ? "Upgrade to an annual plan completely risk free- if you don't earn more than what you pay for the year, get a 100% refund."
            : "300 pitches sent on your behalf per month, no manual work needed"}
        </Typography>
      </Grid>

      <Grid item xs md="auto" sx={{ textAlign: { xs: "center", sm: "left" } }}>
        <Button
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "info.main",
            textTransform: "none",
          }}
          onClick={trackLearnMore}
        >
          Learn More
        </Button>
      </Grid>
    </Grid>
  );
};

export default VAAnnouncement;
